import { getUser } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getUser";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { isE2E } from "@faire/web/common/user-agent/isE2E";
import React, { Suspense } from "react";

import { LazyBugReportingWidget } from "./LazyBugReportingWidget";

export const BugReportingWidget = React.memo(() => {
  const isSSR = useIsSSR();
  if (isE2E() || isSSR) {
    return null;
  }

  const user = getUser();
  if (user?.is_employee || user?.impersonating) {
    // /api/jira/issues/ is only accessible for employees and impersonating users
    // TODO: remove this restriction on the backend for whitelisted users
    return (
      <Suspense fallback={null}>
        <LazyBugReportingWidget />
      </Suspense>
    );
  }

  return null;
});
